export const CHART_STYLES = {
    AUTOCALL_RENDEMENT: {
        rendement: {
            color: "#01002D",
            strokeWidth: 3,
            strokeDasharray: [7, 4]
        },
        coupon_conditionnel_maximum: {
            color: "#256EFF"
        },
        coupon_conditionnel_minimum: {
            color: "#DB7F67"
        },
        barriere_de_coupon_conditionnel_minimum: {
            color: "#F45B69"
        },
        barriere_de_protection_du_capital: {
            color: "#E4FF1A"
        },
        seuil_autocall: {
            color: "#3DDC97"
        },
        coupon_garanti: {
            color: "#623CEA"
        }
    },
    CAP: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        strike_cap: {
            color: "#DB7F67"
        }
    },
    CAP_KO: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        strike_cap: {
            color: "#DB7F67"
        },
        strike_ko: {
            color: "#F45B69"
        }
    },
    COLLAR: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        strike_floor: {
            color: "#623CEA"
        },
        strike_cap: {
            color: "#DB7F67"
        }
    },
    COLLAR_KI_KO: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        strike_floor: {
            color: "#623CEA"
        },
        strike_ki: {
            color: "#256EFF"
        },
        strike_cap: {
            color: "#DB7F67"
        },
        strike_ko: {
            color: "#F45B69"
        },
        strike: {
            color: "#041d5e", 
            strokeWidth: 3,
            strokeDasharray: [7, 4]
        }
    },
    COLLAR_KO: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        strike_floor: {
            color: "#623CEA"
        },
        strike_cap: {
            color: "#DB7F67"
        },
        strike_ko: {
            color: "#F45B69"
        },
        strike: {
            color: "#041d5e", 
            strokeWidth: 3,
            strokeDasharray: [7, 4]
        }
    },
    SWAP: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        taux_fixe: {
            color: "#F45B69"
        },
    },
    SWAP_KO: {
        couverture: {
            color: "#01002D",
            strokeWidth: 3
        },
        indice_sous_jacent: {
            color: "#3DDC97",
            strokeWidth: 3
        },
        strike_floor: {
            color: "#623CEA"
        },
        strike_ko: {
            color: "#F45B69"
        }
    },
    TARF: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike: {
            color: "#9B489B"
        }
    },
    TERME_ACCUMULATEUR_KO: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike: {
            color: "#9B489B"
        },
        borne_basse: {
            color: "#623CEA",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        borne_haute: {
            color: "#256EFF",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        }
    },
    TERME_ASYMETRIQUE: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike: {
            color: "#9B489B",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
    },
    TERME_ASYMETRIQUE_DESACTIVANT: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike: {
            color: "#9B489B",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        ko: {
            color: "#f0ac69"
        },
        ko_line: {
            color: "#01002D",
        }
    },
    TERME_PARTICIPATIF: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike: {
            color: "#9B489B",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        ki: {
            color: "#256EFF"
        },
        line: {
            color: "#01002D",
        }
    },
    TERME_SEC: {
        cours_a_terme: {
            color: "#0e2060", 
            strokeWidth: 3
        }
    },
    TUNNEL_ASYMETRIQUE: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike1: {
            color: "#9B489B",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        strike2: {
            color: "#776871",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        line: {
            color: "#01002D",
            strokeWidth: 3,
        }
    },
    WEDDING_CAKE_ACCUMULATEUR: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        strike_bonifie: {
            color: "#776871"
        },
        strike_degrade: {
            color: "#9B489B"
        },
        borne_basse: {
            color: "#623CEA",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        borne_haute: {
            color: "#256EFF", 
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        }
    },
    WEDDING_CAKE_OPTIONS: {
        montant_max: {
            color: "#f0ac69", 
            strokeWidth: 12
        },
        montant_min: {
            color: "#9bbb59", 
            strokeWidth: 3
        },
        cours_a_terme: {
            color: "#000000", 
            strokeDasharray: [5, 5], 
            strokeWidth: 0.5
        },
        strike_bonifie: {
            color: "#776871",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        strike_degrade: {
            color: "#9B489B",
            strokeDasharray: [2, 2],
            strokeWidth: 0.5
        },
        borne_basse: {
            color: "#623CEA",
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        borne_haute: {
            color: "#256EFF", 
            strokeDasharray: [7, 4],
            strokeWidth: 0.5
        },
        montant_dotted: {
            color: "#041d5e",
            strokeDasharray: [2, 2],
            strokeWidth: 0.5
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/config/ChartStyles.ts